// src/shared/ui/Card/Card.tsx
import React from 'react';
import './Card.scss';

type Props = {
  title?: string;
  className?: string;
  rightSlot?: React.ReactNode;
  children: React.ReactNode;
};

export const Card: React.FC<Props> = ({ title, className = '', rightSlot, children }) => {
  return (
    <div className={`ui-card ${className}`}>
      {(title || rightSlot) && (
        <div className="ui-card__head">
          {title && <div className="ui-card__title">{title}</div>}
          {rightSlot && <div className="ui-card__right">{rightSlot}</div>}
        </div>
      )}
      <div className="ui-card__body">{children}</div>
    </div>
  );
};
